import Api from './Api'
import moment from "moment";


export default {
  getavailabilities(token) {
    const headerData = {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json;version=1.1;sandbox'
      }
    }
    const postData = {
      category_id: 0,
      from_date: moment()
        .startOf("year")
        .format("YYYY-MM-DD"),
      to_date: moment()
      .endOf("year")
      .add(3, "years")
      .format("YYYY-MM-DD")
    }
    return Api().post('/availability/', postData, headerData)
  },

}
